import { useState } from "react";
import { motion } from "framer-motion";
import { Info } from "lucide-react";
import { GIFTS, FILTERS } from "../data/site";
import Reveal from "./Reveal";

export default function GiftCatalog() {
  const [filter, setFilter] = useState("Semua Hadiah");
  const shown = filter === "Semua Hadiah" ? GIFTS : GIFTS.filter((g) => g.category === filter);

  return (
    <section id="hadiah" data-testid="katalog-hadiah" className="scroll-mt-20 bg-cream py-20 text-night md:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-bold tracking-[0.3em] text-emerald">KOLEKSI HADIAH</p>
          <h2 className="mt-4 text-3xl font-black leading-tight sm:text-4xl md:text-5xl">
            KALIAN TRADE. GANDAKAN PROFIT. <span className="text-emerald">HADIAH MILIK KALIAN</span>
          </h2>
          <p className="mt-4 text-sm font-light text-night/65 md:text-base">
            Dari gadget sehari-hari sampai perjalanan impian. Temukan milestone hadiah untuk akun BOOSTER kalian.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-8 flex flex-wrap justify-center gap-2">
          {FILTERS.map((f) => (
            <button
              key={f}
              data-testid={`filter-${f.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setFilter(f)}
              className={`rounded-full px-4 py-2.5 text-xs font-bold transition-all duration-300 sm:text-sm ${
                filter === f
                  ? "bg-emerald text-cream shadow-lg"
                  : "border border-night/10 bg-white text-night/70 hover:border-emerald"
              }`}
            >
              {f}
            </button>
          ))}
        </Reveal>

        <p data-testid="gift-count" className="mt-8 text-center text-xs font-light text-night/50">
          {shown.length} hadiah ditampilkan
        </p>

        <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 xl:grid-cols-4">
          {shown.map((g, i) => (
            <motion.article
              key={`${filter}-${g.id}`}
              data-testid={`gift-card-${g.id}`}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group flex h-full flex-col overflow-hidden rounded-2xl bg-white text-center shadow-[0_2px_12px_rgba(8,13,11,0.08)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-12px_rgba(8,13,11,0.25)]"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={g.img}
                  alt={g.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col gap-1 p-3.5 md:p-4">
                <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-emerald md:text-[11px]">
                  {g.category}
                </p>
                <h3 className="text-sm font-black leading-snug md:text-base">{g.name}</h3>
                <div className="mt-auto pt-2.5">
                  <span
                    data-testid={`gift-lots-${g.id}`}
                    className="inline-flex items-baseline gap-1 rounded-full bg-night px-3.5 py-2 text-sm font-bold text-gold md:text-base"
                  >
                    {g.lots}
                    <span className="text-[10px] font-semibold text-goldlight">lot</span>
                  </span>
                </div>
              </div>
            </motion.article>
          ))}
        </div>

        <Reveal className="mx-auto mt-12 flex max-w-2xl items-start justify-center gap-2 text-center">
          <Info className="mt-0.5 h-4 w-4 shrink-0 text-night/40" />
          <p className="text-xs font-light italic text-night/55 md:text-sm">
            Foto merupakan contoh visual hadiah. Model, warna, spesifikasi, periode program, kelayakan lot, dan
            mekanisme klaim mengikuti ketentuan penyelenggara.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
